<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <h5>Raise New Incident</h5>
        <hr />
        <form @submit.prevent="raiseNewIncident" class="p-1 mb-3">
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label>Event</label>
                <v-select
                  class="style-chooser"
                  v-model="incidentCategoryId"
                  :options="options.incidentCategory"
                  label="category_name"
                  :reduce="(category) => category.id"
                  background-color="white"
                  placeholder="Select Incident Event"
                  required
                ></v-select>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label>Incident Source</label>
                <v-select
                  class="style-chooser"
                  v-model="incidentSourceId"
                  :options="options.incidentSource"
                  label="source_name"
                  :reduce="(source) => source.id"
                  placeholder="Select Incident Source"
                  required
                ></v-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label>Category</label>
                <v-select
                  class="style-chooser"
                  v-model="subCategoryId"
                  :options="options.subCategory"
                  label="sub_category_name"
                  :reduce="(subCategory) => subCategory.id"
                  required
                  :disabled="incidentCategoryId == 1"
                ></v-select>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label>Chainage No.</label>
                <input
                  name="chNo"
                  placeholder="Enter Chainage Location"
                  type="text"
                  class="form-control inp-bg"
                  v-model="chainageNo"
                  required
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label>Description</label>
                <textarea
                  class="form-control inp-bg"
                  v-model="incidentDescription"
                  rows="5"
                  required
                  placeholder="More details about the incident"
                ></textarea>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label>Side</label>
                <v-select
                  class="style-chooser"
                  v-model="sideId"
                  :options="options.side"
                  label="side_name"
                  :reduce="(side) => side.id"
                  placeholder="Select Side"
                  required
                ></v-select>
              </div>
              <div class="mb-3">
                <label>Informed To</label>
                <v-select
                  class="style-chooser"
                  v-model="informedTo"
                  :options="options.informedTo"
                  label="firstName"
                  :reduce="(user) => user.userId"
                  placeholder="Select RPO"
                  required
                ></v-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6" v-if="incidentCategoryId === 1">
              <div class="mb-3">
                <label>Driver Name</label>
                <input
                  name="driverName"
                  placeholder="Enter Driver Name"
                  type="text"
                  class="form-control inp-bg"
                  v-model="driverName"
                  required
                />
              </div>
            </div>
          </div>

          <!-- RPO -->
          <div class="row" v-if="incidentCategoryId === 1">
            <div class="col-6 col-xl-6">
              <div class="mb-3" v-if="userRole === 'rpo'">
                <label>Vehicle Number</label>
                <input
                  name="vehicleNumber"
                  placeholder="Vehicle Plate Number"
                  type="text"
                  class="form-control inp-bg"
                  v-model="vehicleNumber"
                  maxlength="10"
                  style="text-transform: uppercase"
                  required
                />
              </div>
            </div>
            <div class="col-6 col-xl-6">
              <div class="mb-3">
                <label>No. of Injured People</label>
                <input
                  placeholder="No. of Injured People"
                  type="number"
                  class="form-control inp-bg"
                  v-model="injuredCount"
                  required
                />
              </div>
            </div>
          </div>

          <!-- Image Upload -->
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label>Incident Images</label>
                <file-pond
                  ref="pond"
                  class="inp-bg"
                  label-idle="Attach Incident Images"
                  :allow-multiple="true"
                  accepted-file-types="image/jpeg, image/png"
                  max-files="6"
                  :files="myFiles"
                  :credits="credits"
                  imagePreviewMaxHeight="70"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label>Capture from Device</label>
                <div class="row">
                  <div class="col-4">
                    <button class="btn btn-sm btn-primary w-100">
                      Capture from Front Camera
                    </button>
                  </div>
                  <div class="col-4">
                    <button class="btn btn-sm btn-primary w-100">
                      Capture from Rear Camera
                    </button>
                  </div>
                  <div class="col-4">
                    <button class="btn btn-sm btn-primary w-100">
                      Capture from Body Camera
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- BUTTON -->
          <div class="row">
            <hr />
            <div class="col-12 text-center">
              <button class="btn btn-primary w-50">Save</button>
            </div>
            <!-- <div class="col-6">
              <button class="btn btn-success me-1 w-100">Resolve</button>
            </div> -->
          </div>
        </form>
      </div>
    </div>
  </Layout>
</template>

<script>
import incidentMixin from "@/mixins/incident";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import Layout from "@/layouts/main";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

import appConfig from "@/app.config";
import Swal from "sweetalert2";

export default {
  mixins: [incidentMixin],

  page: {
    title: "Raise New Incident",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    FilePond,
    Layout,
  },
  data() {
    return {
      incidentCategoryId: null,
      subCategoryId: null,
      incidentSourceId: null,
      incidentDescription: null,
      chainageNo: null,
      sideId: null,
      vehicleNumber: null,
      driverName: null,
      injuredCount: null,
      incidentDate: null,
      incidentTime: null,
      informedTo: null,
      credits: "",
      userRole: null,
      challanStatusId: null,

      options: {
        incidentCategory: [],
        subCategory: [],
        incidentSource: [],
        side: [],
        informedTo: [],
      },

      image: "",
      file: "",
      myFiles: [],
    };
  },

  watch: {
    incidentCategoryId: function () {
      if (this.incidentCategoryId == 1) this.subCategoryId = null;
    },
  },

  methods: {
    async getIncidentMasters() {
      try {
        const incidents = await this.GetIncidentMasters();
        this.options.incidentCategory = incidents.getIncidentCategory;
        this.options.subCategory = incidents.getIncidentSubCategory;
        this.options.incidentSource = incidents.getIncidentSource;
        this.options.side = incidents.getIncidentSide;
        this.options.informedTo = incidents.rpoData;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        Swal.fire(
          "Network Error",
          "Failed to fetch data from the server. Please check your internet connection.",
          "error"
        );
      }
    },

    async raiseNewIncident() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        const incidentDetails = {
          categoryId: this.incidentCategoryId,
          subCategoryId: this.subCategoryId,
          sourceId: this.incidentSourceId,
          description: this.incidentDescription,
          chainageNo: this.chainageNo,
          sideId: this.sideId,
          vehicleNo: this.vehicleNumber,
          driverName: this.driverName,
          injuredCount: this.injuredCount,
          rpoId: this.informedTo,
          reportedBy: this.$store.getters["auth/user"].user.id,
          challanStatusId: this.challanStatusId,
        };

        const res = await this.SaveIncident(incidentDetails);

        await this.saveIncidentImages(res.id);

        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire(
          "Incident Raised",
          `Incident with ID: ${res.id} has been raised and notifications have been sent to respective RPO team.`,
          "success"
        ).then(() => {
          this.clearData();
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Error Occurred", e.response.data.message, "error");
        this.clearData();
      }
    },

    async saveIncidentImages(incidentId) {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        if (this.$refs.pond) {
          const files = this.$refs.pond.getFiles();
          for (let file of files) {
            let formData = new FormData();
            formData.append("photo", file.file);
            formData.append("id", incidentId);
            await this.SaveIncidentImages(formData);
          }
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Error Occurred", e.response.data.message, "error");
        this.clearData();
      }
    },

    getUsers() {
      this.userRole = this.$store.getters["auth/user"].user.role;
    },

    clearData() {
      this.incidentCategoryId = null;
      this.subCategoryId = null;
      this.incidentSourceId = null;
      this.incidentDescription = null;
      this.chainageNo = null;
      this.sideId = null;
      this.vehicleNumber = null;
      this.incidentDate = null;
      this.incidentTime = null;
      this.informedTo = null;

      if (this.$refs.pond) {
        this.$refs.pond.removeFiles();
      }

      this.$emit("closeModal");
    },

    formatDate(d) {
      const date = new Date(d);
      let day = date.getDate();
      let month = date.getMonth() + 1;
      if (month < 10) month = "0" + month;
      let year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
  },
  async mounted() {
    this.$store.dispatch("layout/changeLoaderValue", true);
    await this.getIncidentMasters();
    this.$store.dispatch("layout/changeLoaderValue", false);
    this.getUsers();
    this.informedTo = this.$store.getters["auth/user"].user.first_name;
  },
};
</script>
<style>
.filepond--root {
  font-family: "Poppins", sans-serif;
}

.filepond--panel-root {
  background-color: #2a3042;
}

.filepond--drop-label {
  color: #a6b0cf;
  font-size: 10px;
}

textarea::placeholder,
input::placeholder {
  color: #717174 !important;
}

.vs__search::placeholder,
.vs__dropdown-toggle,
.vs__selected,
.vs__dropdown-menu {
  background: #2a3042;
  border: none;
  color: #a6b0cf;
  font-size: 13px;
}

.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected .vs--disabled::placeholder {
  background-color: #1a2031;
  color: #1a2031;
}

.vs__disabled-bg {
  background: #333f78;
}

.vs__clear,
.vs__open-indicator {
  fill: #394066;
}

@media (min-width: 30em) {
  .filepond--item {
    width: calc(50% - 0.5em);
  }
}

@media (min-width: 50em) {
  .filepond--item {
    width: calc(16.66% - 0.5em);
  }
}

.footer-raise-btn {
  position: fixed;
  bottom: 80px;
  width: 97%;
}
</style>
